import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const nexusApi = axios.create({ baseURL: `${BACKEND}/api/nexus` });

nexusApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("nexus_buyer_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

const Ctx = createContext(null);

export function NexusAuthProvider({ children }) {
  const [buyer, setBuyer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("nexus_buyer_token");
    if (!t) { setLoading(false); return; }
    nexusApi.get("/me")
      .then((r) => setBuyer(r.data.buyer))
      .catch(() => localStorage.removeItem("nexus_buyer_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await nexusApi.post("/auth/login", { email, password });
    localStorage.setItem("nexus_buyer_token", r.data.token);
    setBuyer(r.data.buyer);
    return r.data.buyer;
  };

  const register = async (payload) => {
    const r = await nexusApi.post("/auth/register", payload);
    localStorage.setItem("nexus_buyer_token", r.data.token);
    setBuyer(r.data.buyer);
    return r.data.buyer;
  };

  const logout = () => {
    localStorage.removeItem("nexus_buyer_token");
    setBuyer(null);
  };

  return (
    <Ctx.Provider value={{ buyer, loading, login, register, logout }}>{children}</Ctx.Provider>
  );
}

export const useNexusAuth = () => useContext(Ctx);
